import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

export function InternalRoute() {
  const { custom_claims } = useSelector(({ user }) => user.auth)

  const hasInternalAccess = custom_claims?.isInternalAppUser === true

  if (!hasInternalAccess) {
    return <Navigate replace to="/" />
  }

  return <Outlet />
}
